import { Injectable } from '@angular/core';
import {RendererFunction} from "@feature/_app_modules/composite-details/types/renderer-function";
import * as renderers from '../renderers';

/**
 * An Angular-friendly service which provides a front-end into the registry of renderers.
 */
@Injectable({ providedIn:'root'})
export class NodeComponentRendererFactoryService {
    private readonly cache : Map<string,RendererFunction> = new Map<string, RendererFunction>();

    getRenderer(name: string) { return this.cache.get(name); }

    constructor() {
        this.cache.set('Anchor', renderers.anchorRendererFunc);
        this.cache.set('DetailsItem', renderers.detailsItemRendererFunc);
        this.cache.set('Field', renderers.fieldRendererFunc);
        this.cache.set('RelatedContactItem', renderers.relatedContactItemRendererFunc);
        this.cache.set('RelatedContactView', renderers.relatedContactViewRendererFunc);
        this.cache.set('Section', renderers.sectionRendererFunc);
        this.cache.set('StringValue', renderers.stringValueRendererFunc);
        this.cache.set('SectionWithSubtitle', renderers.sectionWithSubtitleRendererFunc);
        this.cache.set('DownloadableFileList', renderers.downloadableFileListRendererFunc);
        this.cache.set('NoticeBoardDownloadableFile', renderers.downloadableNoticeboardAttachmentFileRendererFunc);
    }
}
